<template>
  <v-app id="novelReviewers">
    <link rel="stylesheet"
          href="https://fonts.googleapis.com/css?family=Roboto%20Mono:300,400">

    <v-main class="pa-5">
      
      <router-view></router-view>  
        
    </v-main>

    <v-bottom-navigation
      app
      class="pt-2"
    >

      <v-btn key="dashboard" :to="{ name: 'Dashboard'}" exact>
        <span>Dashboard</span>
        <v-icon>mdi-view-dashboard</v-icon>
      </v-btn>

      <v-btn key="book-list" :to="{ name: 'BookList'}">
        <span>Read</span>
        <v-icon>mdi-book</v-icon>
      </v-btn>

      <v-btn v-if="authenticatedUser" key="account" :to="{ name: 'Account' }">
        <span>Account</span>
        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-btn v-else key="login" :to="{ name: 'Authenticate' }">
        <span>Login</span>
        <v-icon>mdi-login</v-icon>
      </v-btn>

      

    </v-bottom-navigation>

  </v-app>
</template>

<script>
  export default {
    props: {
      source: String,
    },
    data: () => ({
      
    }),
    created: function () {
      this.$vuetify.theme.dark = this.$store.getters.darkmode;
    },
   
    computed: {
      authenticatedUser: function() {
        return this.$store.getters.user.authenticated;
      }
    }
  }
</script>

<style lang="scss">
#novelReviewers {
  font-family: 'Roboto Mono';
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>